var React = require('react');

function Family (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.93478 7.45455C5.45608 7.45455 7.5 5.01246 7.5 2H5.06522C2.54392 2 0 4.44208 0 7.45455H2.93478ZM10.5 2C13.3815 2 16 4.44208 16 7.45455H13.7174C10.8359 7.45455 8.5 5.01246 8.5 2H10.5ZM7.5 14C7.5 10.9875 5.45608 8.54545 2.93478 8.54545H0C0 11.5579 2.54392 14 5.06522 14H7.5ZM16 8.54545C16 11.5579 13.3815 14 10.5 14H8.5C8.5 10.9875 10.8359 8.54545 13.7174 8.54545H16Z","fill":"black"}));
}

Family.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Family;

Family.default = Family;
